import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'

export const Rail = styled(Box)({
  background: 'var(--bg-canvas)',
  borderRight: '1px solid var(--line)',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  minWidth: 0,
}) as typeof Box

export const RailHeader = styled(Box)({
  padding: '14px 16px 10px',
  borderBottom: '1px solid var(--line)',
})

export const SearchBar = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  padding: '6px 10px',
  background: 'var(--bg-app)',
  border: '1px solid var(--line)',
  borderRadius: 'var(--r-sm)',
  cursor: 'pointer',
  transition: 'border-color var(--t-fast) var(--ease)',
  outline: 'none',
  '&:focus-within': {
    boxShadow: 'var(--ring)',
    borderColor: 'var(--accent-text)',
  },
})

export const RailContent = styled(Box)({
  flex: 1,
  overflowY: 'auto',
  padding: '10px 8px 20px',
})

export const RailSection = styled(Box)({ marginBottom: 18 })

export const SectionHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '6px 8px',
  fontSize: 10,
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '0.1em',
  color: 'var(--text-quaternary)',
})

export const SectionCount = styled('span')({
  fontFamily: 'var(--font-mono)',
  background: 'var(--bg-app)',
  padding: '1px 6px',
  borderRadius: 4,
  fontSize: 10,
  fontWeight: 600,
})

export const ProjectRow = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '28px 1fr auto auto auto',
  gap: 6,
  alignItems: 'center',
  padding: '7px 8px',
  borderRadius: 'var(--r-sm)',
  cursor: 'pointer',
  transition: 'background var(--t-fast) var(--ease)',
  outline: 'none',
  '&:hover': { background: 'var(--bg-hover)' },
  '&[data-active="true"]': { background: 'var(--accent-bg)' },
  '& .delete-btn': { opacity: 0, transition: 'opacity var(--t-fast) var(--ease)' },
  '&:hover .delete-btn': { opacity: 1 },
  '& .pin-btn': { opacity: 0, transition: 'opacity var(--t-fast) var(--ease)' },
  '&:hover .pin-btn': { opacity: 1 },
  '& .pin-btn[data-pinned="true"]': { opacity: 1 },
})

export const ProjectIcon = styled(Box)({
  width: 28,
  height: 28,
  borderRadius: 'var(--r-sm)',
  display: 'grid',
  placeItems: 'center',
  fontFamily: 'var(--font-mono)',
  fontSize: 10,
  fontWeight: 700,
  letterSpacing: '-0.02em',
  flexShrink: 0,
})

export const ProjectBadge = styled('span')({
  fontFamily: 'var(--font-mono)',
  fontSize: 9,
  fontWeight: 700,
  padding: '1px 5px',
  borderRadius: 3,
  background: 'var(--bg-app)',
  color: 'var(--text-tertiary)',
  letterSpacing: '0.04em',
})

export const ConvRow = styled(Box)({
  padding: '6px 8px',
  borderRadius: 'var(--r-sm)',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px',
  transition: 'background var(--t-fast) var(--ease)',
  outline: 'none',
  '&:hover': { background: 'var(--bg-hover)' },
  '&[data-active="true"]': { background: 'var(--accent-bg)' },
  '& .delete-btn': { opacity: 0, transition: 'opacity var(--t-fast) var(--ease)' },
  '&:hover .delete-btn': { opacity: 1 },
})

export const EmptyText = styled(Typography)({
  fontSize: 11.5,
  color: 'var(--text-secondary)',
  lineHeight: 1.5,
  padding: '6px 8px 4px',
})
